// extracted by mini-css-extract-plugin
export default {"loading":"style_loading__pwPTs","left":"style_left__XA9a7","right":"style_right__c4xEC"};